export const AUTH_START = "AUTH_START";
export const AUTH_SUCCESS = "AUTH_SUCCESS";
export const AUTH_FAIL = "AUTH_FAIL";
export const AUTH_LOGOUT = "AUTH_LOGOUT";

export const SET_AUTH_REDIRECT_PATH = "SET_AUTH_REDIRECT_PATH";
export const REDIRECT = "REDIRECT";

export const FETCH_USERS_BEGIN = "FETCH_USERS_BEGIN";
export const FETCH_USERS_SUCCESS = "FETCH_USERS_SUCCESS";
export const FETCH_USERS_FAILED = "FETCH_USERS_FAILED";

export const ADD_USER_BEGIN = "ADD_USER_BEGIN";
export const ADD_USER_SUCCESS = "ADD_USER_SUCCESS";
export const ADD_USER_FAILED = "ADD_USER_FAILED";

export const FETCH_USER_BEGIN = "FETCH_USER_BEGIN";
export const FETCH_USER_SUCCESS = "FETCH_USER_SUCCESS";
export const FETCH_USER_FAILED = "FETCH_USER_FAILED";

export const UPDT_USER_SUCCESS = "UPDT_USER_SUCCESS";
export const UPDT_USER_FAILED = "UPDT_USER_FAILED";

export const FETCH_REQUESTS_BEGIN = "FETCH_REQUESTS_BEGIN";
export const FETCH_REQUESTS_SUCCESS = "FETCH_REQUESTS_SUCCESS";
export const FETCH_REQUESTS_FAILED = "FETCH_REQUESTS_FAILED";

export const FETCH_REQUEST_BEGIN = "FETCH_REQUEST_BEGIN";
export const FETCH_REQUEST_SUCCESS = "FETCH_REQUEST_SUCCESS";
export const FETCH_REQUEST_FAILED = "FETCH_REQUEST_FAILED";

export const ADD_REQUEST_BEGIN = "ADD_REQUEST_BEGIN";
export const ADD_REQUEST_SUCCESS = "ADD_REQUEST_SUCCESS";
export const ADD_REQUEST_FAILED = "ADD_REQUEST_FAILED";

export const ADD_REQUEST_MESSAGE_BEGIN = "ADD_REQUEST_MESSAGE_BEGIN";
export const ADD_REQUEST_MESSAGE_SUCCESS = "ADD_REQUEST_MESSAGE_SUCCESS";
export const ADD_REQUEST_MESSAGE_FAILED = "ADD_REQUEST_MESSAGE_FAILED";

export const UPDATE_REQUEST_BEGIN = "UPDATE_REQUEST_BEGIN";
export const UPDATE_REQUEST_SUCCESS = "UPDATE_REQUEST_SUCCESS";
export const UPDATE_REQUEST_FAILED = "UPDATE_REQUEST_FAILED";

export const REMOVE_REQUEST_BEGIN = "REMOVE_REQUEST_BEGIN";
export const REMOVE_REQUEST_SUCCESS = "REMOVE_REQUEST_SUCCESS";
export const REMOVE_REQUEST_FAILED = "REMOVE_REQUEST_FAILED";

export const FETCH_COMPANY_BEGIN = "FETCH_COMPANY_BEGIN";
export const FETCH_COMPANY_SUCCESS = "FETCH_COMPANY_SUCCESS";
export const FETCH_COMPANY_FAILED = "FETCH_COMPANY_FAILED";

export const UPDATE_COMPANY_BEGIN = "UPDATE_COMPANY_BEGIN";
export const UPDATE_COMPANY_SUCCESS = "UPDATE_COMPANY_SUCCESS";
export const UPDATE_COMPANY_FAILED = "UPDATE_COMPANY_FAILED";

export const ADD_COMPANY_BEGIN = "ADD_COMPANY_BEGIN";
export const ADD_COMPANY_SUCCESS = "ADD_COMPANY_SUCCESS";
export const ADD_COMPANY_FAILED = "ADD_COMPANY_FAILED";

export const FETCH_COMPANIES_BEGIN = "FETCH_COMPANIES_BEGIN";
export const FETCH_COMPANIES_SUCCESS = "FETCH_COMPANIES_SUCCESS";
export const FETCH_COMPANIES_FAILED = "FETCH_COMPANIES_FAILED";

export const FETCH_SECTIONS_BEGIN = "FETCH_SECTIONS_BEGIN";
export const FETCH_SECTIONS_SUCCESS = "FETCH_SECTIONS_SUCCESS";
export const FETCH_SECTIONS_FAILED = "FETCH_SECTIONS_FAILED";

export const FETCH_SECTION_BEGIN = "FETCH_SECTION_BEGIN";
export const FETCH_SECTION_SUCCESS = "FETCH_SECTION_SUCCESS";
export const FETCH_SECTION_FAILED = "FETCH_SECTION_FAILED";

export const ADD_SECTION_BEGIN = "ADD_SECTION_BEGIN";
export const ADD_SECTION_SUCCESS = "ADD_SECTION_SUCCESS";
export const ADD_SECTION_FAILED = "ADD_SECTION_FAILED";

export const UPDATE_SECTION_BEGIN = "UPDATE_SECTION_BEGIN";
export const UPDATE_SECTION_SUCCESS = "UPDATE_SECTION_SUCCESS";
export const UPDATE_SECTION_FAILED = "UPDATE_SECTION_FAILED";

export const FETCH_DOCUMENTS_BEGIN = "FETCH_DOCUMENTS_BEGIN";
export const FETCH_DOCUMENTS_SUCCESS = "FETCH_DOCUMENTS_SUCCESS";
export const FETCH_DOCUMENTS_FAILED = "FETCH_DOCUMENTS_FAILED";

export const FETCH_ADDRESSES_BEGIN = "FETCH_ADDRESSES_BEGIN";
export const FETCH_ADDRESSES_SUCCESS = "FETCH_ADDRESSES_SUCCESS";
export const FETCH_ADDRESSES_FAILED = "FETCH_ADDRESSES_FAILED";

export const FETCH_ADDRESS_BEGIN = "FETCH_ADDRESS_BEGIN";
export const FETCH_ADDRESS_SUCCESS = "FETCH_ADDRESS_SUCCESS";
export const FETCH_ADDRESS_FAILED = "FETCH_ADDRESS_FAILED";

export const ADD_ADDRESS_BEGIN = "ADD_ADDRESS_BEGIN";
export const ADD_ADDRESS_SUCCESS = "ADD_ADDRESS_SUCCESS";
export const ADD_ADDRESS_FAILED = "ADD_ADDRESS_FAILED";

export const UPDATE_ADDRESS_BEGIN = "UPDATE_ADDRESS_BEGIN";
export const UPDATE_ADDRESS_SUCCESS = "UPDATE_ADDRESS_SUCCESS";
export const UPDATE_ADDRESS_FAILED = "UPDATE_ADDRESS_FAILED";

export const FETCH_CONTACTS_BEGIN = "FETCH_CONTACTS_BEGIN";
export const FETCH_CONTACTS_SUCCESS = "FETCH_CONTACTS_SUCCESS";
export const FETCH_CONTACTS_FAILED = "FETCH_CONTACTS_FAILED";

export const FETCH_CONTACT_BEGIN = "FETCH_CONTACT_BEGIN";
export const FETCH_CONTACT_SUCCESS = "FETCH_CONTACT_SUCCESS";
export const FETCH_CONTACT_FAILED = "FETCH_CONTACT_FAILED";

export const ADD_CONTACT_BEGIN = "ADD_CONTACT_BEGIN";
export const ADD_CONTACT_SUCCESS = "ADD_CONTACT_SUCCESS";
export const ADD_CONTACT_FAILED = "ADD_CONTACT_FAILED";

export const UPDATE_CONTACT_BEGIN = "UPDATE_CONTACT_BEGIN";
export const UPDATE_CONTACT_SUCCESS = "UPDATE_CONTACT_SUCCESS";
export const UPDATE_CONTACT_FAILED = "UPDATE_CONTACT_FAILED";

/*export const FETCH_DOCUMENTS_BEGIN = 'FETCH_DOCUMENTS_BEGIN';
export const FETCH_DOCUMENTS_SUCCESS = 'FETCH_DOCUMENTS_SUCCESS';
export const FETCH_DOCUMENTS_FAILED = 'FETCH_DOCUMENTS_FAILED';*/



// WEBPACK FOOTER //
// ./src/store/actions/actionTypes.js